module.exports = __webpack_public_path__ + "img/compact.18567d1e.png";